export async function assertPrintEntitlement(trustId, journeyId, format) {
  if (!trustId || !journeyId || !['standard', 'large-text', 'easy-read'].includes(format)) {
    throw new Error('Select an explicitly licensed Journey before printing.');
  }
  const query = new URLSearchParams({ trustId, journeyId, format });
  const response = await fetch('/api/studio-print-entitlement?' + query, {
    credentials: 'same-origin', cache: 'no-store',
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.ok || payload.allowed !== true) {
    throw new Error(payload.error || 'This Journey is not included in the Trust print agreement, or review is incomplete.');
  }
  return true;
}
